import { RegistrationHistoryStatusTypes } from '@App/forms/filters/reg-history-filter'

export enum RegistrationStatus {
    pending = 'pending',
    processing = 'processing',
    completed = 'completed',
    needs_attention = 'needs_attention',
}

export interface RegistrationStatusAndFilters {
    status: RegistrationStatus
    defaultFilters: RegistrationHistoryStatusTypes[]
}
